import { datadogRum } from '@datadog/browser-rum';
import envConfig from '@hulu/env-config';

datadogRum.init({
  applicationId: envConfig.REACT_APP_DATADOG_APPLICATION_ID || '',
  clientToken: envConfig.REACT_APP_DATADOG_CLIENT_TOKEN || '',
  site: 'datadoghq.com',
  service: 'mission-control',
  env: envConfig.REACT_APP_DATADOG_ENV || '',
  // Deployed git SHA (injected by K8s as APP_VERSION, forwarded as REACT_APP_BUILD_SHA
  // in serve/config/env-config.ts) so RUM sessions are attributable to a build instead
  // of a static placeholder. Falls back to '1.0.0' for local/build-time runs.
  version: envConfig.REACT_APP_BUILD_SHA || '1.0.0',
  sessionSampleRate: 100,
  // RUM 6 defaults replay sampling to 0 and the privacy level to 'mask', so both are set explicitly
  // to keep the previous behavior: record every sampled session and mask only form inputs.
  sessionReplaySampleRate: 100,
  defaultPrivacyLevel: 'mask-user-input',
  // Replay starts from the startSessionReplayRecording() call below, as it did before RUM 6.
  startSessionReplayRecordingManually: true,
  trackUserInteractions: true,
  allowedTracingUrls: [
    ...(envConfig.REACT_APP_CAMPAIGN_GRAPHQL_ORIGIN ? [envConfig.REACT_APP_CAMPAIGN_GRAPHQL_ORIGIN] : []),
    ...(envConfig.REACT_APP_CAMPAIGN_MANAGER_ORIGIN ? [envConfig.REACT_APP_CAMPAIGN_MANAGER_ORIGIN] : []),
    ...(envConfig.REACT_APP_CAMPAIGN_SEARCHER_ORIGIN ? [envConfig.REACT_APP_CAMPAIGN_SEARCHER_ORIGIN] : []),
    ...(envConfig.REACT_APP_ASSET_MANAGER_ORIGIN ? [envConfig.REACT_APP_ASSET_MANAGER_ORIGIN] : []),
    ...(envConfig.REACT_APP_CREATIVE_MANAGER_ORIGIN ? [envConfig.REACT_APP_CREATIVE_MANAGER_ORIGIN] : []),
    ...(envConfig.REACT_APP_INVENTORY_GRAPHQL_API ? [envConfig.REACT_APP_INVENTORY_GRAPHQL_API] : []),
  ],
});

datadogRum.startSessionReplayRecording();
